module.exports = __webpack_public_path__ + "media/images/flags/4x3/gin-ea1b6b3ed0ee052f825de216b7291b4a.svg";